import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedSymantecSESApp from "./EmbeddedSymantecSESApp";
const SymantecSESApp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Symantec SES Integrations" }, /* @__PURE__ */ React.createElement("span", null, "This feature retrieves events and incidents from Symantec SES platform.")), /* @__PURE__ */ React.createElement(EmbeddedSymantecSESApp, null));
export default SymantecSESApp;
